/**
 * Created by thiago on 22/11/16.
 */
angular.module('appSite').value('config', {
  baseUrl: "https://api.partiudoarsangue.com.br"
});
